export default __webpack_public_path__ + "static/media/specialrule2.1b448102.svg";